import { duration } from 'src/replicant/utils/duration';
import { tuple } from 'src/replicant/utils/types';
import { FateStateScheduleRecord } from './fate.schema';

export const fatePermanentStatusEffects = tuple(
  'evolving',
  'sick',
  'toothDecay',
  'scared',
  'asleep',
  'dying',
  'dead',
  'hadVisitor',
  'wantToGoOut',
);

export const fateAttributesStatusEffect = tuple(
  'very_dirty',
  'very_hungry',
  'very_lonely',
  'very_pee',
  'very_sad',
  'dirty',
  'hungry',
  'lonely',
  'pee',
  'sad',
  'happy',
  'normal',
);

export const fateState = tuple(
  ...fatePermanentStatusEffects,
  ...fateAttributesStatusEffect,
);

// What period of time we check
export const checkStepInterval = duration({ minutes: 5 });

// What period of time we check
export const maxScheduleLength = duration({ days: 2 });

// Dying moratorium interval after sick
export const dyingMoratoriumInterval = duration({ hours: 2 });
// Dying cooldown interval after previous dying status was resolved
export const dyingCooldownInterval = duration({ hours: 3 });

// Sick cooldown interval after sick resolved
// Used only for death feature!
export const sickCooldownInterval = duration({ hours: 2 });

// Dead moratorium interval after dying
export const deadMoratoriumInterval = duration({ hours: 3 });

// Tooth decay cooldown interval after tooth decay resolved
// Used only with death feature!
export const toothDecayCooldownInterval = duration({ hours: 2 });

// Scared cooldown interval after tooth scared resolved
// Used only with death feature!
export const scaredCooldownInterval = duration({ hours: 2 });

// In this period pet can't get dead status
export const safeTimePeriod = {
  startHour: 22,
  endHour: 9,
};

// Types definitions
export type FatePermanentStatusEffect = typeof fatePermanentStatusEffects[number];
export type FateAttributesStatusEffect = typeof fateAttributesStatusEffect[number];
export type FateState = typeof fateState[number];
export type FateStateRecord = FateStateScheduleRecord & {
  value: boolean;
};
export type FateSchedule = Record<FateState, FateStateScheduleRecord>;
